import request from './axios';

/**
 * 获取常见问题
 * @returns {Promise<Object>} 返回常见问题列表
 */
export function getFaqs(data,params) {
  return request({ 
    url: '/no-auth/txt/faq/list',
    method: 'post',
    data,
    params
  });
}